"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelBrightnessCorrection = exports.CollectionModelBrightnessCorrectionMutator = void 0;
const brightnessCorrection_state_1 = require("./brightnessCorrection.state");
class CollectionModelBrightnessCorrectionMutator {
    constructor(brightnessCorrection) {
        this.brightnessCorrection = brightnessCorrection;
    }
    setValue(state) {
        this.brightnessCorrection.collectionState.setFieldValue(this.brightnessCorrection.instanceId, state);
    }
    /** Gives a shallow clone of the brightness correction state */
    getValue() {
        return Object.assign({}, this.brightnessCorrection.state);
    }
    /**
     * Remove the state of this brightness correction
     * *Warning:* You will need to unlink & remove the brightness correction from the list before destroying the state.
     * @see CollectionModelBrightnessCorrectionStateMutator.remove
     */
    destroyState() {
        this.brightnessCorrection.collectionState.setFieldValue(this.brightnessCorrection.instanceId, null);
    }
    /**
     * Remove the brightness correction,
     * This will unlink and destroy the brightness correction and all associated values.
     *
     * @see CollectionModelBrightnessCorrectionStateMutator.remove
     */
    remove() {
        this.brightnessCorrection.brightnessCorrectionState.Mutator.remove(this.brightnessCorrection);
    }
}
exports.CollectionModelBrightnessCorrectionMutator = CollectionModelBrightnessCorrectionMutator;
class CollectionModelBrightnessCorrection {
    constructor(state, brightnessCorrectionId, captureId) {
        this.instanceId = brightnessCorrection_state_1.CollectionModelBrightnessCorrectionState.brightnessCorrectionId(captureId, brightnessCorrectionId);
        this.id = brightnessCorrectionId;
        this.captureId = captureId;
        this.brightnessCorrectionState = state;
    }
    get state() {
        return this.collectionState.getFieldValue(this.instanceId);
    }
    get collectionState() {
        return this.brightnessCorrectionState.collection.state;
    }
    get isDeletable() {
        return true;
    }
}
exports.CollectionModelBrightnessCorrection = CollectionModelBrightnessCorrection;
//# sourceMappingURL=brightnessCorrection.js.map